import { IUser } from '@interfaces/IUser';
import { Action } from '@ngrx/store';

export enum EProfileActions {
  GetEmailTokenValidity = '[Profile] Get Email Token Validity',

  VerifyPhoneRequest = '[Profile] Verify Phone Request',
  VerifyPhoneRequestSuccess = '[Profile] Verify Phone Request Success',
  VerifyPhoneRequestFailure = '[Profile] Verify Phone Request Failure',

  VerifyPhone = '[Profile] Verify Phone',
  VerifyPhoneSuccess = '[Profile] Verify Phone Success',
  VerifyPhoneFailure = '[Profile] Verify Phone Failure',

  VerifyEmailFetch = '[Profile] Verify Email Fetch',
  VerifyEmailFetchFailure = '[Profile] Verify Email Fetch Failure',

  VerifyEmailRequest = '[Profile] Verify Email Request',
  VerifyEmailRequestSuccess = '[Profile] Verify Email Request Success',
  VerifyEmailSuccess = '[Profile] Verify Email Success',

  EditSelfProfile = '[Profile] Edit Self Profile',
  EditSelfProfileSuccess = '[Profile] Edit Self Profile Success',
  EditSelfProfileFailure = '[Profile] Edit Self Profile Failure',

  ChangePassword = '[Profile] Change Password',
  ChangePasswordSuccess = '[Profile] Change Password Success',
  ChangePasswordFailure = '[Profile] Change Password Failure',

  ClearSuccessState = '[Profile] Clear Success State',
}

export class ClearSuccessState implements Action {
  public readonly type = EProfileActions.ClearSuccessState;
}

export class EditSelfProfile implements Action {
  public readonly type = EProfileActions.EditSelfProfile;

  constructor(public id: number, public userData: IUser) {}
}

export class EditSelfProfileSuccess implements Action {
  public readonly type = EProfileActions.EditSelfProfileSuccess;

  constructor(public userData: IUser) {}
}

export class EditSelfProfileFailure implements Action {
  public readonly type = EProfileActions.EditSelfProfileFailure;

  constructor(public errors: { [key: string]: string[] }) {}
}

export class ChangePasswordSuccess implements Action {
  public readonly type = EProfileActions.ChangePasswordSuccess;
}

export class ChangePassword implements Action {
  public readonly type = EProfileActions.ChangePassword;

  constructor(
    public passwordData: {
      old_password: string;
      password: string;
      password_confirm: string;
    }
  ) {}
}

export class ChangePasswordFailure implements Action {
  public readonly type = EProfileActions.ChangePasswordFailure;

  constructor(public errors: { [key: string]: string[] }) {}
}

export class VerifyEmailFetch implements Action {
  public readonly type = EProfileActions.VerifyEmailFetch;
}

export class GetEmailTokenValidity implements Action {
  public readonly type = EProfileActions.GetEmailTokenValidity;

  constructor(public token: string, public user: IUser) {}
}

export class VerifyEmailRequestSuccess implements Action {
  public readonly type = EProfileActions.VerifyEmailRequestSuccess;

  constructor(public message: string) {}
}

export class VerifyPhoneRequest implements Action {
  public readonly type = EProfileActions.VerifyPhoneRequest;
}

export class VerifyPhoneRequestSuccess implements Action {
  public readonly type = EProfileActions.VerifyPhoneRequestSuccess;

  constructor(public message: string) {}
}

export class VerifyPhone implements Action {
  public readonly type = EProfileActions.VerifyPhone;

  constructor(public code: string) {}
}

export class VerifyPhoneSuccess implements Action {
  public readonly type = EProfileActions.VerifyPhoneSuccess;
}

export class VerifyEmailRequest implements Action {
  public readonly type = EProfileActions.VerifyEmailRequest;
}

export class VerifyEmailFetchFailure implements Action {
  public readonly type = EProfileActions.VerifyEmailFetchFailure;

  constructor(public errors: { [key: string]: string[] }) {}
}

export class VerifyEmailSuccess implements Action {
  public readonly type = EProfileActions.VerifyEmailSuccess;
}

export class VerifyPhoneRequestFailure implements Action {
  public readonly type = EProfileActions.VerifyPhoneRequestFailure;

  constructor(public errors: { [key: string]: string[] }) {}
}

export class VerifyPhoneFailure implements Action {
  public readonly type = EProfileActions.VerifyPhoneFailure;

  constructor(public errors: { [key: string]: string[] }) {}
}

export type ProfileActions =
  | ClearSuccessState
  | ChangePasswordSuccess
  | ChangePassword
  | ChangePasswordFailure
  | EditSelfProfile
  | EditSelfProfileSuccess
  | EditSelfProfileFailure
  | VerifyPhone
  | VerifyPhoneSuccess
  | VerifyEmailSuccess
  | VerifyEmailRequest
  | VerifyPhoneRequest
  | VerifyEmailFetch
  | VerifyEmailRequestSuccess
  | VerifyPhoneRequestSuccess
  | VerifyPhoneRequestFailure
  | VerifyEmailFetchFailure
  | VerifyPhoneFailure;
